module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/feature_4-fe44472babc57b7e4ec7d3080a52515e.png";